import script from "./NotificationBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBanner.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBanner.vue?vue&type=style&index=0&id=a78fb4c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a78fb4c8"]])

export default __exports__